export default "__VITE_ASSET__ac1535f7__"